var PanelHeaderItemView;

PanelHeaderItemView = Marionette.ItemView.extend( {
	template: '#tmpl-kitbuilder-panel-header',

	id: 'kitbuilder-panel-header',

	ui: {
		menuButton: '#kitbuilder-panel-header-menu-button',
		addButton: '#kitbuilder-panel-header-add-button'
	},

	events: {
		'click @ui.addButton': 'onClickAdd',
		'click @ui.menuButton': 'onClickMenu'
	},

	onClickAdd: function() {
		kitbuilder.getPanelView().setPage( 'elements' );
	},

	onClickMenu: function() {
		var panel = kitbuilder.getPanelView(),
			currentPanelPageName = panel.getCurrentPageName(),
			nextPage = 'menu' === currentPanelPageName ? 'elements' : 'menu';

		panel.setPage( nextPage );
	}
} );

module.exports = PanelHeaderItemView;
